import { render, staticRenderFns } from "./boaiFT.vue?vue&type=template&id=92652b5a&scoped=true"
import script from "./boaiFT.vue?vue&type=script&lang=js"
export * from "./boaiFT.vue?vue&type=script&lang=js"
import style0 from "./boaiFT.vue?vue&type=style&index=0&id=92652b5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92652b5a",
  null
  
)

export default component.exports